import { createToast, ToastOptions } from 'mosha-vue-toastify'
import 'mosha-vue-toastify/dist/style.css'

export const useToast = () => {
    const toast = (message: { title: string, description: string}, options: ToastOptions) => {
        createToast(message, options)
    }
    return { toast }
}
